module.exports = __webpack_public_path__ + "img/bottom_logo.e47fc322.png";